import React, { useEffect, useRef, useState } from 'react';
import scrollama from 'scrollama'; // Import Scrollama
import './sec18.css';
import redArrow from './red_arrow.png';

const Sec18 = () => {
    const [isActive, setIsActive] = useState(false);
    const scrollerRef = useRef(null);

    useEffect(() => {
        if (scrollerRef.current) {
            const scroller = scrollama(); // Create a new Scrollama instance
            scroller.setup({
                step: scrollerRef.current,  // Use the ref's current value
                offset: 0.5,  // Trigger at the middle of the viewport
                once: true   // Trigger only once
            })
            .onStepEnter(() => {
                setIsActive(true); // Set active to true when in view
            });

            return () => scroller.destroy(); // Cleanup on unmount
        }
    }, [scrollerRef.current]); // Rerun effect when scrollerRef.current changes

    return (
        <div className="sec18-section">
            <h1 className="sec18-title">
                <span className="text-red">Redlining</span>,
                <span className="text-green"> Speculation</span>,
                <span className="text-purple"> Displacement</span>
            </h1>
            <h1 className="sec18-title2">
                <span className="text-white"> in the City of Boston</span>
                <p className="names">Vojta Machytka, Alex Paskov, Lydia J Patterson, Isabella Pedraza Pineros</p>
            </h1>
            <img
                ref={scrollerRef}
                src={redArrow}
                alt="Red Arrow"
                style={{ width: '400px', height: 'auto' }}
                className={isActive ? 'fade-in' : ''}
            />
        </div>
    );
};

export default Sec18;
